/**
 * @fileOverview Footer collapse class
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires integration-common-files:delegate
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

import delegate from 'integration-common-files/src/js/00-utilities/delegate';

/**
 * Collapse footer links on mobile
 */
export default class Collapse {
  constructor() {
    delegate({
      target: '.ac-footer-links__toggle',
      listener: this.onClickAccordionHeader.bind( this ),
      event: 'click'
    })
  }

  /**
   * Handle open or close
   */
  onClickAccordionHeader( e ) {
    e.preventDefault();
    const collapse = e.target.parentElement;
    collapse.classList.contains( 'js-is--open' ) ?
      this.close( collapse ) : this.open( collapse );
  }

  /**
   * Open collapse
   */
  open( collapse ) {
    const content = collapse.querySelector( '.ac-footer-links__list' );
    if ( !content.dataset.maxHeight ) {
      this._computeMaxHeight( content );
    }
    // Add Max height
    content.style.maxHeight = `${content.dataset.maxHeight}px`;
    collapse.classList.add( 'js-is--open' );
  }

  /**
   * Close collapse
   */
  close( collapse ) {
    const content = collapse.querySelector( '.ac-footer-links__list' );
    this._removeMaxHeight( content );
    collapse.classList.remove( 'js-is--open' );
  }

  /**
   * Compute max height of the collapse's content
   */
  _computeMaxHeight( content ) {
    content.style.maxHeight = 'none';
    content.dataset.maxHeight = content.offsetHeight;
    content.style.maxHeight = '';
    // FORCE REPAINT (Make transition working after repaint)
    content.clientWidth;
  }

  /**
   * Remove max height
   */
  _removeMaxHeight( content ) {
    content.style.maxHeight = '';
  }
}
